export const CollectionCommands = {
    GET_COLLECTION_API: '[collection] GET_COLLECTION_API',
    GET_COLLECTION_API_SUCCESS: '[collection] GET_COLLECTION_API_SUCCESS',
    GET_COLLECTION_CACHED_SUCCESS: '[collection] GET_COLLECTION_CACHED_SUCCESS',
    GET_COLLECTION_API_ERROR: '[collection] GET_COLLECTION_API_ERROR',

    SET_COLLECTION_SLUG_CACHED: '[collection] SET_COLLECTION_SLUG_CACHED',
    SET_COLLECTION_GROUP: '[collection] SET_COLLECTION_GROUP',

    HANDLE_COLLECTION_OF_COLLECTIONS: '[collection] HANDLE_COLLECTION_OF_COLLECTIONS',
};
